import { TypeTable } from '../../../../../../../../shared/components/table/table.component.tsx';
import { Theme as theme } from '../../../../../../../../shared/styles/theme/theme.ts';

export const viewRows: TypeTable['viewRows'] = {
  action: ({ row }) => {
    if (row.isDuplicate) {
      return 'isDuplicate';
    }
    if (row.isRecordWhichOverwrites) {
      return 'isRecordWhichOverwrites';
    }
    return '';
  },
  styles: [
    {
      className: 'isRecordWhichOverwrites',
      bgColor: theme.palette.blue.light,
      bgColorHover: theme.palette.blue.main,
    },
    {
      className: 'isDuplicate',
      bgColor: theme.palette.orange.light,
      bgColorHover: theme.palette.orange.main,
    },
  ],
};

// Period rows have their own two states: a duplicate of another period in the
// same file (the import keeps only the last one), and a period for an article
// the tenant does not have (the import skips it - a price list never creates
// article master data).
export const specialPricesViewRows: TypeTable['viewRows'] = {
  action: ({ row }) => {
    if (row.isUnknownArticle) {
      return 'isUnknownArticle';
    }
    if (row.isDuplicate) {
      return 'isDuplicate';
    }
    return '';
  },
  styles: [
    {
      className: 'isUnknownArticle',
      bgColor: theme.palette.red.light,
      bgColorHover: theme.palette.red.main,
    },
    {
      className: 'isDuplicate',
      bgColor: theme.palette.orange.light,
      bgColorHover: theme.palette.orange.main,
    },
  ],
};
